import { useApi } from "@core/api";
import { useQueryClient } from "@tanstack/react-query";
import { useHookedQuery } from "./useHookedQuery";

const addressBookQueryKey = [ "addressBook" ] as const;

export const useAddressBook = () => {
  const api = useApi();

  const queryClient = useQueryClient();

  const query = useHookedQuery({
    queryKey: addressBookQueryKey,
    queryFn: () => api["/addressbook"](),
  });

  const reload = () => {
    queryClient.invalidateQueries({ queryKey: addressBookQueryKey });
  };

  return { ...query, reload };
};
